import { type BillingCheckoutInput, BillingInterval, SelfServePlan } from '@af/shared';

const KEY = 'af.planChoice';

/**
 * The tier picked on mandistry.com (`/register?plan=team&interval=year`, also accepted on `/login`)
 * survives sign-up and e-mail verification in sessionStorage, so `/billing` can preselect it.
 * Invalid values are ignored; storage failures (private mode) only lose the preselection.
 */
export function rememberPlanChoice(search: string): void {
  const params = new URLSearchParams(search);
  const plan = SelfServePlan.safeParse(params.get('plan'));
  if (!plan.success) return;
  const interval = BillingInterval.safeParse(params.get('interval'));
  const choice: BillingCheckoutInput = {
    plan: plan.data,
    interval: interval.success ? interval.data : 'month',
  };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(choice));
  } catch {}
}

export function planChoice(): BillingCheckoutInput | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? SelfServePlan.safeParse(JSON.parse(raw).plan) : null;
    const interval = raw ? BillingInterval.safeParse(JSON.parse(raw).interval) : null;
    return parsed?.success && interval?.success ? { plan: parsed.data, interval: interval.data } : null;
  } catch {
    return null;
  }
}
